import { useMemo } from "react"
import { SupportedTokenName } from "@mezo/sdk"
import { Tooltip, TooltipProps } from "@mezo-org/mezo-clay"

import { useTokenUsdPrice } from "#/shared/hooks"
import { separateThousandsWithComma } from "#/shared/utils"

type OverviewTokenUsdValueProps = Omit<TooltipProps, "content" | "children"> & {
  amount: bigint
  token: SupportedTokenName
  decimals: number
}

export default function OverviewTokenUsdValue({
  amount,
  token,
  decimals,
  ...props
}: OverviewTokenUsdValueProps) {
  const { getTokenUsdValueLabel } = useTokenUsdPrice()

  const tokenUsdValue = useMemo(
    () => getTokenUsdValueLabel(BigInt(amount), token, decimals),
    [amount, getTokenUsdValueLabel, token, decimals],
  )

  if (Number(tokenUsdValue) < 0.01) {
    return (
      <Tooltip position="right" content={`$${tokenUsdValue}`} {...props}>
        {"$<0.01"}
      </Tooltip>
    )
  }

  return <>${separateThousandsWithComma(tokenUsdValue, 2)}</>
}
